module.exports = __webpack_public_path__ + "img/close.9427a0b6.svg";